module.exports = __webpack_public_path__ + "img/1584651775.6b90a716.jpg";